import React from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

import Ducky from 'assets/duck.jpeg';
import { H1, H2 } from 'components/Typography';

const Header = styled.header`
  background: ${theme.B400};
  padding: 35px 25px;
  text-align: center;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;

  .Header__logo {
    display: inline-block;
    width: 150px;
    height: auto;
    margin-bottom: 25px;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
    animation-duration: 0.85s;
    animation-fill-mode: both;

    &:hover {
      animation-name: rubberBand;
    }
  }
`;

const SiteTitle = H1.extend`
  font-size: 3rem;
  line-height: 1;
  text-transform: uppercase;
  color: ${theme.A500};
  margin: 0 0 15px;

  @media screen and (max-width: 800px) {
    font-size: 2rem;
  }
`;

const SiteSubtitle = H2.extend`
  font-size: 2rem;
  line-height: 1;
  text-transform: uppercase;
  color: ${theme.font_secondary};

  @media screen and (max-width: 800px) {
    font-size: 1.4rem;
  }
`;

export default () => (
  <Header>
    <img className="Header__logo" src={Ducky} alt="Chris Tieman" />
    <SiteTitle>Chris Tieman</SiteTitle>
    <SiteSubtitle>Developer // Ducky // Cat Father</SiteSubtitle>
  </Header>
);



// WEBPACK FOOTER //
// ./src/components/HeaderMain.js